// eslint-disable-next-line @typescript-eslint/no-var-requires
const uniqid = require("uniqid");

export default function generateId(): string {
  return uniqid();
}
